export default __webpack_public_path__ + "static/media/universal_payment_left.571a52fc.png";